<h1 mat-dialog-title>{{ isEditMode ? 'Editar carpeta' : 'Crear carpeta' }}</h1>

<mat-dialog-content [formGroup]="form">
  <div class="row">
    <div class="col-12">
      <mat-form-field appearance="outline" class="full-width mt-2">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="name" [placeholder]="isEditMode ? 'Editar nombre' : 'Nombre'" />
      </mat-form-field>
    </div>
    @if (this.isUserAdmin()) {
      <div class="col-12">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Departamentos con acceso</mat-label>
          <mat-select formControlName="categories" multiple>
            @for (category of availableDepartments; track category) {
              <mat-option [value]="category.id">
                {{ category.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="!form.valid">
    {{ isEditMode ? 'Actualizar' : 'Crear' }}
  </button>
</mat-dialog-actions>
